// extracted by mini-css-extract-plugin
module.exports = {"hidden":"applyStep_hidden__iVl_D","textEmphasis":"applyStep_textEmphasis__MXDe0","processResultArea":"applyStep_processResultArea__xRDO6"};